import { queryOptions } from '@tanstack/react-query';
import { maxTagsQueryOptions } from '#api/tags.queries.ts';

/**
 * Fetches all tags and maps them to select items.
 */
export const allTagsQueryOptions = queryOptions({
  ...maxTagsQueryOptions,
  select: (data) => ({
    items: data.data.map((tag) => ({ value: tag.name, label: tag.name })),
  }),
});
